/**
 * @desc 根据国家名字列表获取国家列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CountryResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/country/getCountryListByCountryNames`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
